<template>
	<v-card class="elevation-3" color="white">
		<div class="text-center font-weight-black ma-4 title pa-4">
			<h3>Increase your visibility to see more offers</h3>
		</div>

		<div class="text-center ma-4 pa-4">
			<v-btn depressed rounded color="primary" class="white--text text-none font-weight-bold" @click="locumSetAvailability()"
				>Set availability
				<v-icon right>mdi-arrow-right</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { bus } from '@/main';

export default {
	name: 'LocumIncreaseAvailabilityAd',
	components: {},
	data: () => ({}),
	created() {},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {
		locumSetAvailability() {
			bus.$emit('change-context', 'locum-set-availability');
		},
	},
};
</script>
